import { Component, OnInit } from "@angular/core";
import { Branch } from "./branch-settings.interface";
import { BranchSettingsService } from "./branch-settings.service";
import { MatTableDataSource } from "@angular/material/table";
import { AuthService } from "../auth/auth.service";
import { ConfirmationDialogComponent } from "../shared/confirmation-dialog/confirmation-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { ToastrTranslatedService } from "../shared/toastr-translated.service";
import { BranchEditDialogComponent } from "./branch-edit-dialog/branch-edit-dialog.component";

@Component({
  selector: "app-branch-settings",
  templateUrl: "./branch-settings.component.html",
  styleUrls: ["./branch-settings.component.scss"],
  standalone: false,
})
export class BranchSettingsComponent implements OnInit {
  public displayedColumns = [
    "name",
    "employeesCount",
    "createdAt",
    "modifiedAt",
    "actions",
  ];
  public dataSource = new MatTableDataSource<Branch>();
  public isLoading = true;

  constructor(
    private readonly service: BranchSettingsService,
    private dialog: MatDialog,
    private translate: TranslateService,
    private toastr: ToastrTranslatedService,
    public auth: AuthService,
  ) {}

  ngOnInit(): void {
    this.fetchBranches();
  }

  fetchBranches = () => {
    this.isLoading = true;
    this.service.fetchBranches().subscribe({
      next: (branches) => {
        this.dataSource.data = branches;
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      },
    });
  };

  removeBranch = (branchId: string) => {
    this.dialog
      .open(ConfirmationDialogComponent, {
        data: {
          title: this.translate.instant(
            "branchSettings.deleteConfirmationText",
          ) as string,
        },
      })
      .afterClosed()
      .subscribe(async (confirm) => {
        if (confirm) {
          await this.service
            .removeBranch(branchId)
            .toPromise()
            .then(() => {
              this.fetchBranches();
              this.toastr.success(
                this.translate.instant(
                  "branchSettings.deleteSuccess",
                ) as string,
              );
            });
        }
      });
  };

  editBranch = (branch: Branch) => {
    this.dialog
      .open(BranchEditDialogComponent, {
        data: branch,
        width: "90vw",
        maxWidth: "1400px",
        height: "90vh",
        maxHeight: "900px",
        panelClass: "app-dialog-panel",
      })
      .afterClosed()
      .subscribe((response) => {
        if (response) {
          this.fetchBranches();
          this.toastr.success(
            this.translate.instant("branchSettings.changeSuccess") as string,
          );
        }
      });
  };

  addBranch = () => {
    this.dialog
      .open(BranchEditDialogComponent, {
        data: null,
        width: "90vw",
        maxWidth: "1400px",
        height: "90vh",
        maxHeight: "900px",
        panelClass: "app-dialog-panel",
      })
      .afterClosed()
      .subscribe((response) => {
        if (response) {
          this.fetchBranches();
          this.toastr.success(
            this.translate.instant("branchSettings.addSuccess") as string,
          );
        }
      });
  };
}
